import { ScreenLayoutProvider } from './ScreenLayoutProvider';
import { Sidebar } from './Sidebar';
import { useScreenSidebar } from './useScreenSidebar';
import { Main, Section } from './styled';
/**
 * Layout component that provides a screen with an optional contextual sidebar, header and main content area.
 */
export function Root(props) {
    const { topbar, contentBar, content, sidebar, floatingSidebar, id, state = 'ready', sidebarDefaultOpen } = props;
    const { layoutRef } = useScreenSidebar(id, sidebarDefaultOpen);
    return (<ScreenLayoutProvider id={id} state={state}>
      <Section>
        {topbar}

        {contentBar}

        <Main ref={layoutRef}>
          {content}
          {sidebar && <Sidebar>{sidebar}</Sidebar>}
          {floatingSidebar}
        </Main>
      </Section>
    </ScreenLayoutProvider>);
}
